<template>
  <div class="app">
    <the-navigation v-if="showNavAndFooter" data-aos="fade-right"></the-navigation>
    <main
      :class="{
        'home-page': $route.path === '/',
        'page-content': $route.path !== '/',
        'ordering': $route.path === '/Ordering'
      }"
    >
      <router-view></router-view>
    </main>
    <the-footer v-if="showNavAndFooter"></the-footer>
  </div>
</template>

<script>
import TheNavigation from "./components/TheNavigation.vue";
import TheFooter from "./components/TheFooter.vue";
import { mapActions } from "vuex";
export default {
  components: { TheNavigation, TheFooter },
  
  async created() {
    await this.fetchProducts();
  },

  computed: {
    showNavAndFooter() {
      const routes = ['/Ordering'];
      return !routes.includes(this.$route.path);
    }
  },
  
  methods: {
    ...mapActions(['fetchProducts'])
  }
};
</script>


